import { Segmented } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { DealType } from '../../types';

/**
 * An investor may hold both kinds of investment at once. The two are stored in separate tables and
 * are never aggregated together, so a tab shows one book at a time and this chooses which.
 *
 * The unselected side is passed as an element but never rendered, so its queries do not run until
 * the switch is actually flipped.
 */
export default function DealBookSwitch({
  book,
  onChange,
  percentage,
  fixed,
}: {
  book: DealType;
  onChange: (book: DealType) => void;
  percentage: ReactNode;
  fixed: ReactNode;
}) {
  const { t } = useTranslation();

  return (
    <>
      <Segmented<DealType>
        value={book}
        onChange={onChange}
        style={{ marginBottom: 16 }}
        options={[
          { label: t('forms.percentageBook'), value: 'PercentageBased' },
          { label: t('forms.fixedBook'), value: 'FixedReturn' },
        ]}
      />
      {book === 'FixedReturn' ? fixed : percentage}
    </>
  );
}
